module.exports = __webpack_public_path__ + "static/media/ReactIcon.81134bd2.svg";